/* Barra fija v2 — la barra deja de ser un botón aparte y pasa a ser un espejo
 * del buy box, con las DOS maneras de comprar el producto a mano.
 *
 * El problema que resolvió la v2: al elegir «Receta» en el tipo de lente, el
 * botón de la página cambiaba a «Continuar con tu receta» y la barra seguía
 * ofreciendo «LOS QUIERO». La única fuente de verdad es el botón de la página:
 * la barra copia su texto, su estado y su acción.
 *
 * Lo que agrega esta versión: la compra con receta. En un armazón óptico el 75%
 * de las órdenes lleva receta, y la barra solo ofrecía «Agregar al carro». Ahora,
 * donde la ficha ofrece receta (LensAdvisor o el selector de tipo de lente), la
 * barra muestra dos botones. Cuál es el sólido lo decide la plantilla con el
 * ajuste «la receta es la acción principal» (data-bb-receta="primaria" en el
 * buy box): en ópticos, Fiore, clip y ópticos deportivos manda la receta; en
 * lectura y sol manda el carro. El sólido va siempre a la derecha, donde llega
 * el pulgar.
 *
 * Además: primario de 48 px y 16 px de texto, la receta como botón de 48 px y
 * no como enlace subrayado de 10 px, y los chips de variante fuera de la barra
 * (medían 23 px; el mínimo táctil es 44).
 */
(function () {
  'use strict';

  var barra = document.querySelector('.bb-sticky-v4');
  var scope = document.querySelector('[data-bb-ficha-v2]');
  if (!barra || !scope) return;

  document.documentElement.classList.add('bb-barra-v2');

  /* Siempre el mismo texto, corto, en las tres familias. El de LensAdvisor
     cambia por tipo de producto («Personalizar con o sin receta» en sol: 29
     caracteres, no cabe en media barra) y el del theme era «Personalizar con
     receta». Comprar con receta es lo que el cliente va a hacer. */
  var ETIQUETA_RECETA = 'Comprar con receta';
  var recetaPrimaria = scope.getAttribute('data-bb-receta') === 'primaria';

  function txt(el) {
    return (el ? (el.innerText || el.textContent || '') : '').replace(/\s+/g, ' ').trim();
  }

  /* LensAdvisor escribe sus botones EN MAYÚSCULAS; la ficha habla en tipo oración. */
  function oracion(s) {
    if (s === s.toUpperCase() && s.length > 3) return s.charAt(0) + s.slice(1).toLowerCase();
    return s;
  }

  /* El botón de compra de la página: puede ser el del theme o, cuando el cliente
     elige receta, el de LensAdvisor. Se toma el que esté visible. */
  function visible(e) {
    if (!e) return false;
    var cs = window.getComputedStyle(e);
    return e.getClientRects().length > 0 && cs.visibility !== 'hidden' && cs.display !== 'none';
  }

  /* La fuente de verdad es lo que el cliente ELIGIÓ en el selector de tipo de
     lente (.bb-sl__tab.is-active), no cuál botón se ve. En algunas fichas, al
     elegir «Receta» quedan los dos botones visibles a la vez, y adivinar por
     visibilidad hacía que la barra ofreciera «Agregar al carro» mientras la
     página ofrecía «Comprar con receta». */
  function tipoElegido() {
    var tab = scope.querySelector('.bb-sl__tab.is-active, .bb-sl__tab[aria-checked="true"]');
    return tab ? txt(tab).toLowerCase() : null;
  }

  function botonLensAdvisor() {
    // LensAdvisor inyecta su botón después de que corre este archivo: hay que
    // buscarlo cada vez, nunca guardarlo al cargar. En ópticos y Fiore el
    // selector de tipo de lente lo deja oculto a propósito (el flujo se abre
    // por .click(), que funciona aunque no se vea).
    return document.querySelector('lensadvizor-btn, #la-select-lenses-btn, .la-select-lenses-btn');
  }

  function botonPagina() {
    // Al elegir «Receta» el theme reemplaza el botón por .bb-sl__receta-cta
    // («Continuar con tu receta»), que no existe hasta ese momento: los otros
    // dos se ocultan, y mirar solo esos dejaba a la barra sin fuente.
    var cta = scope.querySelector('.bb-sl__receta-cta');
    var receta = botonLensAdvisor();
    var carro = scope.querySelector('.add-to-cart, [data-add-to-cart]');
    if (visible(cta)) return cta;
    var tipo = tipoElegido();
    if (tipo && /recet/.test(tipo) && visible(receta)) return receta;
    if (visible(receta) && /continuar/i.test(txt(receta)) && !visible(carro)) return receta;
    if (visible(carro)) return carro;
    if (visible(receta)) return receta;
    return null;
  }

  /* ¿La ficha ofrece comprar con receta? Por dos caminos: la pestaña «Receta»
     del selector de tipo de lente (ópticos, Fiore) o el botón de LensAdvisor
     (lectura, sol, clip, deportivos). Accesorios: ninguno. */
  function receta() {
    var tab = scope.querySelector('.bb-sl__tab[data-mode="receta"]');
    var la = botonLensAdvisor();
    return { tab: tab, la: la, hay: !!(tab || la) };
  }

  var espejos = barra.querySelectorAll('.bb-sticky-v4__atc');
  var rxs = barra.querySelectorAll('.bb-sticky-v4__rx');

  /* El theme calcula el alto de la barra una sola vez al cargar y posiciona
     con top: calc(100vh - alto). Con dos botones la barra crece: si no se
     recalcula, la fila de abajo queda fuera de la pantalla. */
  function medirAltura() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var h = barra.offsetHeight;
    if (h) document.documentElement.style.setProperty('--bb-sticky-h', h + 'px');
  }

  /* El globo del bot de Bonoboss (widget.js del bot, montado en #bb-widget con
     shadow DOM) se sienta a 16 px del borde inferior: justo encima del botón
     derecho de la barra, y le come la última palabra. Las hojas de estilo de
     la página no entran al shadow root, así que se le sube el bottom desde
     aquí mientras la barra está a la vista. Lo limpio sería que el propio
     widget leyera --bb-sticky-h; mientras, esto. */
  function acomodarChat() {
    var host = document.getElementById('bb-widget');
    var raiz = host && host.shadowRoot;
    if (!raiz) return;
    var burbuja = raiz.querySelector('#bb-burbuja');
    var teaser = raiz.querySelector('#bb-teaser');
    var movil = window.matchMedia('(max-width: 749px)').matches;
    /* U07: con un 2.º par de sol elegido, el módulo esconde la barra mientras
       está en pantalla (html.bb-sp-sol-barra-off). Si el globo del chat no se
       entera, se queda flotando a la altura de una barra que ya no está. El
       MutationObserver de `arrancar` vigila la clase de <html>, así que esto
       corre solo al ponerla y al quitarla. */
    var oculta = document.documentElement.classList.contains('bb-sp-sol-barra-off');
    var aLaVista = !oculta && (document.documentElement.classList.contains('bb-cta-lejos') || barra.classList.contains('is-visible'));
    var alza = (movil && aLaVista) ? barra.offsetHeight + 12 : 0;
    if (burbuja) burbuja.style.bottom = alza ? alza + 'px' : '';
    if (teaser) teaser.style.bottom = alza ? (alza + 68) + 'px' : '';
  }

  /* La barra copia el texto y el estado del botón de la página, y decide si
     muestra una acción o dos. */
  function espejar() {
    var fuente = botonPagina();
    if (!fuente || !espejos.length) return;
    var etiqueta = oracion(txt(fuente));
    if (!etiqueta) return;
    var apagado = !!(fuente.disabled || /agotado|vendido/i.test(etiqueta));
    // Si el espejo YA es la receta («Continuar con tu receta»), la segunda
    // acción sobra: una sola.
    var esReceta = /recet/i.test(etiqueta);
    var r = receta();
    var dos = !esReceta && !apagado && r.hay;

    Array.prototype.forEach.call(espejos, function (b) {
      if (txt(b) !== etiqueta) b.textContent = etiqueta;
      b.disabled = apagado;
      b.setAttribute('data-bb-espejo', 'si');
    });
    Array.prototype.forEach.call(rxs, function (b) {
      b.hidden = !dos;
      if (!dos) return;
      // El theme la esconde con style="display:none" cuando LensAdvisor aún no
      // había cargado; ese estado ya no vale.
      if (b.style.display === 'none') b.style.display = '';
      if (txt(b) !== ETIQUETA_RECETA) b.textContent = ETIQUETA_RECETA;
    });
    barra.setAttribute('data-bb-acciones', dos ? '2' : '1');
    barra.setAttribute('data-bb-primario', (dos && recetaPrimaria) ? 'receta' : 'carro');
    medirAltura();
    acomodarChat();
  }

  /* El clic de la barra dispara el MISMO botón de la página, no una acción
     paralela: así nunca pueden divergir. */
  Array.prototype.forEach.call(espejos, function (espejo) {
    espejo.addEventListener('click', function (e) {
      var fuente = botonPagina();
      if (!fuente || fuente === espejo) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      fuente.click();
      // En ópticos con «Lectura» elegida y sin aumento, el botón de la página
      // no agrega nada: parpadea la pista junto al selector. Desde la barra esa
      // pista no se ve, así que se lleva al cliente hasta ella.
      if (fuente.classList.contains('bb-sl-atc-gated')) {
        var selector = document.getElementById('BbSelectorLente');
        if (selector) selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  });

  /* Comprar con receta desde la barra: en las fichas con selector de tipo de
     lente se elige la pestaña «Receta» (la página queda en ese estado, como si
     el cliente la hubiera tocado) y se sigue con su botón «Continuar con tu
     receta»; en el resto se dispara el botón de LensAdvisor directamente. */
  Array.prototype.forEach.call(rxs, function (rx) {
    rx.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var r = receta();
      if (r.tab) {
        if (!r.tab.classList.contains('is-active')) r.tab.click();
        window.setTimeout(function () {
          var cta = scope.querySelector('.bb-sl__receta-cta');
          if (cta) cta.click();
          else if (r.la) r.la.click();
        }, 60);
        return;
      }
      if (r.la) r.la.click();
    }, true);
  });

  /* Los chips de variante salen de la barra: 23 px no se toca ni se lee.
     Queda el nombre de lo elegido, que lleva al selector de la página. */
  function quitarChips() {
    var grupos = barra.querySelectorAll('.bb-sticky-v4__variants-wrap, .bb-sticky-v4__var-group, .bb-sticky-v4__variants');
    Array.prototype.forEach.call(grupos, function (g) { g.hidden = true; });
    var etiqueta = barra.querySelector('#bbSV4VariantM, .bb-sticky-v4__mob-variant');
    // «Default Title» es el nombre que pone Shopify cuando el producto no tiene
    // variantes: no le dice nada a nadie.
    if (etiqueta && /^default title$/i.test(txt(etiqueta))) {
      etiqueta.hidden = true;
      return;
    }
    var selector = scope.querySelector('.variant-wrapper');
    if (etiqueta && selector && !etiqueta.hasAttribute('data-bb-ancla')) {
      etiqueta.setAttribute('data-bb-ancla', '');
      etiqueta.setAttribute('role', 'button');
      etiqueta.setAttribute('tabindex', '0');
      var ir = function () { selector.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
      etiqueta.addEventListener('click', ir);
      etiqueta.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); ir(); }
      });
    }
  }

  function arrancar() {
    quitarChips();
    espejar();
    if ('MutationObserver' in window) {
      var obs = new MutationObserver(function () { window.setTimeout(espejar, 0); });
      obs.observe(scope, { childList: true, subtree: true, characterData: true, attributes: true,
                           attributeFilter: ['disabled', 'class', 'style', 'hidden'] });
    }
    // Impulse avisa el cambio de variante con dos eventos: variantChange en el
    // contenedor (no burbujea: por eso se escucha en captura) y variant:change
    // en document.
    // La barra aparece y desaparece con la clase bb-cta-lejos en <html>: el
    // globo del chat tiene que seguirla en ese mismo momento, no 1,2 s después.
    if ('MutationObserver' in window) {
      new MutationObserver(acomodarChat).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      new MutationObserver(acomodarChat).observe(barra, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('variantChange', function () { window.setTimeout(espejar, 0); }, true);
    document.addEventListener('variant:change', function () { window.setTimeout(espejar, 0); });
    Array.prototype.forEach.call(scope.querySelectorAll('.bb-sl__tab'), function (tab) {
      tab.addEventListener('click', function () { window.setTimeout(espejar, 120); });
    });
    window.setInterval(espejar, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
